// extracted by mini-css-extract-plugin
export default {"pieNeedle":"DonutProgress_pieNeedle__0Nxt7","pieChart":"DonutProgress_pieChart__mN5yl","button":"DonutProgress_button__eLEMu","countDownTimer":"DonutProgress_countDownTimer__Olm9K"};